// extracted by mini-css-extract-plugin
export var centerAligned = "j_iHYjxovahVydXT4qOk";
export var info = "vfOXVcyo4QaXRUw4w1zy";
export var leftBorder = "jotW73GplNisnfpJoq8T";
export var negative = "QMT4P78AZH5RbJzpuryB";
export var neutral = "uUL5WoahmE8ibnb1_XAn";
export var positive = "E13gGJ6zvF7nfc7vXoKf";
export var primary = "mta4YJr7UBxK5dd8rPy6";
export var root = "qqS3Eg1HbF8i618OkJdR";
export var secondary = "c6k462pQke4L6bEprGBG";
export var title = "MNyvRn2PvqrkSt__FDKA";
export var warning = "zx5OeO33x55Seadoyr4g";
export var withChevron = "P4KCmKctSeamkOQIZ0Tl";